/**
 * Renders sanitised HTML from the backend. Backend already sanitises with OWASP;
 * a client-side allow-list (DOMPurify) is recommended for v1.1.
 */
export function RichText({ html, className }: { html: string; className?: string }) {
  return (
    <div
      className={`prose-body max-w-none ${className ?? ""}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
